'use client';

import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { PageType } from '@/features/Analytics';
import { useBooking } from '../../model/store/booking';
import { TimeSlotsUI } from '../TimeSlots/TimeSlotsUI';
import type { ISchedule } from '@/entities/booking/model/types';
import type { BookingStore } from '../../model/store/booking';
interface Props {
  pageType: PageType;
  schedule: ISchedule[];
  currentBooking: BookingStore;
  doctorId: number;
  hasDaysListButtonOffset?: boolean;
}
export const BookingTimeslots: React.FC<Props> = props => {
  const {
    currentBooking,
    schedule,
    doctorId,
    hasDaysListButtonOffset = false
  } = props;
  const t = useTranslations('doctor.booking.timeslots');
  const {
    setChangedSlot
  } = useBooking();
  const selectedDay = useMemo(() => {
    return currentBooking.changedSlot?.day || null;
  }, [currentBooking.changedSlot]);
  const selectedSlot = useMemo(() => {
    return currentBooking.changedSlot?.slot || '';
  }, [currentBooking.changedSlot]);
  const onDayClick = (day: ISchedule) => {
    setChangedSlot({
      day,
      slot: day.timeslots![0],
      id: doctorId
    });
  };
  const onSlotClick = (slot: string) => {
    if (selectedDay) {
      setChangedSlot({
        day: selectedDay,
        slot,
        id: doctorId
      });
    }
  };
  const setSelectedSlot = (slot: string) => {
    if (selectedDay) {
      setChangedSlot({
        day: selectedDay,
        slot,
        id: doctorId
      });
    }
  };
  return <TimeSlotsUI daysTitle={t('days_title')} slotsTitle={t('timeslots_title')} mini schedule={schedule} selectedDay={selectedDay} selectedSlot={selectedSlot} onDayClick={onDayClick} onSlotClick={onSlotClick} setSelectedSlot={setSelectedSlot} scrollToSelected pageType={props.pageType} hasDaysListButtonOffset={hasDaysListButtonOffset} data-sentry-element="TimeSlotsUI" data-sentry-component="BookingTimeslots" data-sentry-source-file="BookingTimeslots.tsx" />;
};